import React, {useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import {Container} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {tripApi} from '../misc/TripApi'
import {handleLogError} from '../misc/Helpers'
import MyTrips from "./MyTrips";

function MyTripsPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'

  const [tripsMeAsDriver, setTripsMeAsDriver] = useState([])
  const [tripsMeAsPass, setTripsMeAsPass] = useState([])
  const [isTripsLoading, setIsTripsLoading] = useState(false)

  useEffect(() => {
    handleGetTrips()
  }, [])


  const handleGetTrips = async () => {
    try {
      setIsTripsLoading(true)
      const responseMeAsDriver = await tripApi.getTripsMeAsDriver(user)
      setTripsMeAsDriver(responseMeAsDriver.data)
      const responseMeAsPass = await tripApi.getTripsMeAsPass(user)
      setTripsMeAsPass(responseMeAsPass.data)
    } catch (error) {
      handleLogError(error)
    } finally {
      setIsTripsLoading(false)
    }
  }

  const cancelTrip = async (id) => {
    const trip = await tripApi.cancelTrip(user, id)
    const responseMeAsDriver = await tripApi.getTripsMeAsDriver(user)
    setTripsMeAsDriver(responseMeAsDriver.data)
  }

  const completeTrip = async (id) => {
    const trip = await tripApi.completeTrip(user, id)
    const responseMeAsDriver = await tripApi.getTripsMeAsDriver(user)
    setTripsMeAsDriver(responseMeAsDriver.data)
  }


  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <MyTrips
        isTripsLoading={isTripsLoading}
        tripsMeAsDriver={tripsMeAsDriver}
        tripsMeAsPass={tripsMeAsPass}
        cancelTrip={cancelTrip}
        completeTrip={completeTrip}
      />
    </Container>
  )
}

export default MyTripsPage
